import { useEffect, useState } from 'react';

interface PreviewImage {
  src: string;
  alt: string;
}

export default function GlobalImageLightbox() {
  const [previewImage, setPreviewImage] = useState<PreviewImage | null>(null);

  useEffect(() => {
    const handleClick = (event: MouseEvent) => {
      if (window.location.pathname.startsWith('/admin')) {
        return;
      }

      const target = event.target as HTMLElement | null;
      const image =
        (target?.closest('img') as HTMLImageElement | null) ||
        (target?.parentElement?.querySelector(':scope > img') as HTMLImageElement | null);

      if (!image?.src) {
        return;
      }

      const interactiveParent = image.closest('a, button');
      if (interactiveParent) {
        return;
      }

      event.preventDefault();
      setPreviewImage({
        src: image.currentSrc || image.src,
        alt: image.alt || '图片预览',
      });
    };

    document.addEventListener('click', handleClick);

    return () => {
      document.removeEventListener('click', handleClick);
    };
  }, []);

  useEffect(() => {
    if (!previewImage) return;

    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        setPreviewImage(null);
      }
    };

    document.body.style.overflow = 'hidden';
    window.addEventListener('keydown', handleKeyDown);

    return () => {
      document.body.style.overflow = '';
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [previewImage]);

  if (!previewImage) {
    return null;
  }

  return (
    <div
      className="fixed inset-0 z-[100] flex items-center justify-center bg-black/80 p-4"
      onClick={() => setPreviewImage(null)}
      role="dialog"
      aria-modal="true"
      aria-label={previewImage.alt}
    >
      <button
        type="button"
        className="absolute right-4 top-4 rounded-full bg-white/90 px-3 py-2 text-gray-800 shadow hover:bg-white"
        onClick={() => setPreviewImage(null)}
        aria-label="关闭大图"
      >
        <i className="ri-close-line text-2xl"></i>
      </button>
      <img
        src={previewImage.src}
        alt={previewImage.alt}
        className="max-h-[90vh] max-w-[92vw] cursor-zoom-out rounded-lg object-contain shadow-2xl"
        onClick={(event) => event.stopPropagation()}
      />
    </div>
  );
}
